import {
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Switch,
  Typography,
} from "@mui/material";
import utilStyle from "./Utils.module.css";
import pageStyle from "./CustomerDetails.module.css";
import { Delete, Save } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  APIProduct,
  deleteProduct,
  emptyProduct,
  getProduct,
  saveProduct,
} from "../api/products";

function ProductDetailsPage({ id }: { id?: string }) {
  const navigate = useNavigate();

  const [product, setProduct] = useState<APIProduct>(emptyProduct());
  useEffect(() => {
    getProduct(id || undefined).then((v) => setProduct(v));
  }, [id]);

  // Handle changes
  const changeProduct = (change: Partial<APIProduct>) => {
    const update = { ...product, ...change };
    setProduct(update);
    handleSave(update);
  };

  const handleSave = async (updatedProduct: APIProduct) => {
    const p = await saveProduct(updatedProduct);
    if (!updatedProduct.id) {
      navigate(`/products?id=${p.id}`, { replace: true });
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(`Delete ${product.title || "this product"}?`)) {
      return;
    }
    if (id) {
      await deleteProduct(id);
    }
    navigate("/products");
  };

  return (
    <div className={pageStyle.customerDetailPanel} style={{ maxWidth: 640 }}>
      <Typography variant="h5">{product.title || "New product"}</Typography>
      <Typography variant="body2" color="text.secondary">
        {id
          ? "Changes save automatically. Prices here are the defaults for new proposal lines."
          : "Start typing; it saves automatically."}
      </Typography>
      <div>
        <form
          className={pageStyle.editCustomerForm}
          noValidate
          autoComplete="off"
        >
          <FormControl>
            <InputLabel htmlFor="titleInput">Name</InputLabel>
            <OutlinedInput
              value={product.title}
              onChange={(e) => changeProduct({ title: e.target.value })}
              id="titleInput"
              label="Name"
            />
          </FormControl>
          <FormControl>
            <InputLabel htmlFor="descriptionInput">Description</InputLabel>
            <OutlinedInput
              value={product.description}
              onChange={(e) => changeProduct({ description: e.target.value })}
              multiline
              minRows={3}
              id="descriptionInput"
              label="Description"
            />
          </FormControl>
          <FormControl>
            <InputLabel>Price</InputLabel>
            <OutlinedInput
              type="number"
              value={product.price}
              onChange={(e) => changeProduct({ price: Number(e.target.value) })}
              label="Price"
              startAdornment={
                <InputAdornment position="start">$</InputAdornment>
              }
            />
          </FormControl>
          <FormControlLabel
            control={
              <Switch
                checked={product.taxable}
                onChange={(e) => changeProduct({ taxable: e.target.checked })}
              />
            }
            label="Charge sales tax on this product"
          />
        </form>
        <div className={utilStyle.controlHeader}>
          <div className={utilStyle.controlHeaderButtonContainer}>
            {id && (
              <Button color="error" startIcon={<Delete />} onClick={handleDelete}>
                Delete product
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductDetailsPage;
